import { setTheme } from "theme/default/setTheme";

export const setFontSize_15px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_15px}`);
